import { DropdownItem } from 'reactstrap';
import { useDispatch, useSelector } from 'src/store/store';
import ButtonDropdown from 'src/components/buttons/buttonDropdown';
import i18n from 'src/utils/translate';

import { setAlert } from 'src/components/alert/actions';
import { removeMemberFromCommunity } from 'src/api/community';

import { getCanEditBadges, userHasRole } from 'src/utils/context';
import { useModalTrigger } from 'src/utils/hooks';

import { CommunityMember, Role } from 'src/constants/types';
import { ModalType } from 'src/constants/modalTypes';

export default function CommunityMemberCardMenu({ member }: { member: CommunityMember }): JSX.Element {
  const dispatch = useDispatch();
  const { currentUser, currentCommunity } = useSelector(({ context }) => context);

  const triggerRemoveMemberModal = useModalTrigger(ModalType.CommunityRemoveMember, {
    username: member.username,
    onAccept: () => removeMember(),
  });

  const removeMember = async () => {
    const slug = currentCommunity && currentCommunity.slug || '';
    const { data, status } = await removeMemberFromCommunity(slug, member.userId);
    if (status === 200) {
      dispatch(setAlert(i18n.t(`You removed ${member.username} from this community`), 'success'));
    } else {
      const message = data && data.message || i18n.t('There was a problem. Please refresh the page and try again.');
      dispatch(setAlert(message));
    }
  };

  const triggerEditBadgesModal = useModalTrigger(ModalType.EditBadges, { member });

  const canRemove = userHasRole(currentUser, Role.HealthUnlocked);
  const canEditBadges = getCanEditBadges(currentUser?.roles, member?.roles);

  if (!canRemove && !canEditBadges) return null;

  return (
    <ButtonDropdown
      ariaLabel="Options"
      className="community-member-card__btn-dropdown"
      color="none"
      isRightAligned={true}
    >
      {canRemove && (
        <DropdownItem onClick={triggerRemoveMemberModal}>
          {i18n.t('Remove')}
        </DropdownItem>
      )}
      {canEditBadges && (
        <DropdownItem onClick={triggerEditBadgesModal}>
          {i18n.t('Edit badges')}
        </DropdownItem>
      )}
    </ButtonDropdown>
  );
}
